module.exports = require('../each');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@1.3.1@@antv/util/lib/object/for-in.js
// module id = 272
// module chunks = 0 1 2